<ng-container *ngIf="!isMobile">
	<div class="account-section">
		<div class="checkout-success">
			<div class="checkout-success__body">
				<div class="checkout-success__body__headline order-confirmation-headline">
					<h2 class="order-confirmtitle">{{'common.checkout_orderConfirmation_title'|cxTranslate}}</h2>
					<p class="ordertoppara">
						<strong>
							{{'common.checkout_orderConfirmation_thankYouForOrder_bendix'|cxTranslate}}
						</strong>
					</p>
				</div>
				<div class="order-confirmation-summary">
					<div class="order-confirmation-summary-title">
						{{'common.checkout_orderConfirmation_Summary_title'|cxTranslate}}</div>
					<div class="order-confirmation-summary-body">
						<div class="order-confirmation-top-category " [ngClass]="!isMobile ? 'd-flex':''">
							<div class="col-xs-12 col-sm-4 col-md-4 col-lg-4 order-con-order">
								<p class="mb-0">
									<strong>{{'common.checkout_orderConfirmation_Order_ID'|cxTranslate}}</strong>
									<span>&nbsp;{{orderConfirmation?.code}}</span>
								</p>
							</div>
							<div class="col-xs-12 col-sm-4 col-md-4 col-lg-4 order-po-order">
								<p class="mb-0">
									<strong>
										{{'common.order_track_my_status_po'|cxTranslate}}</strong>
									<span>&nbsp;{{ orderConfirmation?.purchaseOrderNumber }}</span>
								</p>
							</div>
							<div class="col-xs-12 col-sm-4 col-md-4 col-lg-4 order-date-order">
								<p class="mb-0">
									<strong>
										{{'common.text_account_table_header_date'|cxTranslate}}:&nbsp;
									</strong>{{orderConfirmation?.kbcreated}}
								</p>
							</div>
						</div>
						<div class="order-confirmation-middle-category" [ngClass]="!isMobile ? 'd-flex':''">
							<div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 order-con-customerID">
								<p class="oc-title">
									<strong>{{'common.checkout_orderConfirmation_Customer_ID'|cxTranslate}}</strong>
								</p>
								<p class="mb-0">{{orderConfirmation?.user?.name}}</p>
								<p class="email mb-0">
									{{orderConfirmation?.user?.uid}}
								</p>
								<ng-container>
									<p class="df-customerID">
										{{orderConfirmation?.currentB2BUnit?.addresses[0]?.sapCustomerID}}<br>
										{{orderConfirmation?.currentB2BUnit?.name}}<br>
										{{orderConfirmation?.currentB2BUnit?.addresses[0]?.line1}}<span
											*ngIf="orderConfirmation?.currentB2BUnit?.addresses[0]?.line2">,
											{{orderConfirmation?.currentB2BUnit?.addresses[0]?.line2}}</span><br>
										<span
											*ngIf="orderConfirmation?.currentB2BUnit?.addresses[0]?.companyAddressTwo">{{orderConfirmation?.currentB2BUnit?.addresses[0]?.companyAddressTwo}}<br></span>
										{{orderConfirmation?.currentB2BUnit?.addresses[0]?.postalCode}}<span
											*ngIf="orderConfirmation?.currentB2BUnit?.addresses[0]?.town">,&nbsp;{{orderConfirmation?.currentB2BUnit?.addresses[0]?.town}}</span><br>
										<span
											*ngIf="orderConfirmation?.currentB2BUnit?.addresses[0]?.region?.name">{{orderConfirmation?.currentB2BUnit?.addresses[0]?.region?.name}}<br></span>
										{{orderConfirmation?.currentB2BUnit?.addresses[0]?.country?.name}}<br><br>
									</p>
								</ng-container>
							</div>
							<div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 order-con-Shipping-Address">
								<p class="oc-title">
									<strong>{{'common.checkout_summary_shippingAddress'|cxTranslate}}</strong>
								</p>
								<p class="mb-0">{{orderConfirmation?.deliveryAddress?.sapCustomerID}}</p>
								<p>
									<span
										*ngIf="orderConfirmation?.deliveryAddress?.companyName">{{orderConfirmation?.deliveryAddress?.companyName}}
										<br></span>
									{{orderConfirmation?.deliveryAddress?.line1}}
									<span
										*ngIf="orderConfirmation?.deliveryAddress?.line2">,&nbsp;{{orderConfirmation?.deliveryAddress?.line2}}</span><br>
									<span
										*ngIf="orderConfirmation?.deliveryAddress?.companyAddressTwo">{{orderConfirmation?.deliveryAddress?.companyAddressTwo}}<br></span>
									{{orderConfirmation?.deliveryAddress?.postalCode}}<span
										*ngIf="orderConfirmation?.deliveryAddress?.town">,&nbsp;{{orderConfirmation?.deliveryAddress?.town}}</span><br>
									<span
										*ngIf="orderConfirmation?.deliveryAddress?.region?.name">{{orderConfirmation?.deliveryAddress?.region?.name}}<br></span>
									{{orderConfirmation?.deliveryAddress?.country?.name}}<br>
								</p><br>
							</div>
							<div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 order-con-Billing-Address">
								<p class="oc-title">
									<strong>{{'common.checkout_orderConfirmation_Billing_Address'|cxTranslate}}</strong>
								</p>
								<ng-container *ngIf="orderConfirmation?.defaultBilling ; else paymentAddress">
									<p class="mb-0">{{orderConfirmation?.defaultBilling?.sapCustomerID}}</p>
									<p>
										<span
											*ngIf="orderConfirmation?.defaultBilling?.companyName">{{orderConfirmation?.defaultBilling?.companyName}}
											<br></span>
										{{orderConfirmation?.defaultBilling?.line1}}
										<span
											*ngIf="orderConfirmation?.defaultBilling?.line2">,&nbsp;{{orderConfirmation?.defaultBilling?.line2}}</span><br>
										<span
											*ngIf="orderConfirmation?.defaultBilling?.companyAddressTwo">{{orderConfirmation?.defaultBilling?.companyAddressTwo}}<br></span>
										{{orderConfirmation?.defaultBilling?.postalCode}},&nbsp;{{orderConfirmation?.defaultBilling?.town}}<br>
										<span
											*ngIf="orderConfirmation?.defaultBilling?.region?.name">{{orderConfirmation?.defaultBilling?.region?.name}}<br></span>
										{{orderConfirmation?.defaultBilling?.country?.name}}<br>
									</p>
								</ng-container>
								<ng-template #paymentAddress>
									<p>{{orderConfirmation?.paymentAddress?.sapCustomerID}}</p>
									<p></p>
									<p>
										<span
											*ngIf="orderConfirmation?.paymentAddress?.companyName">{{orderConfirmation?.paymentAddress?.companyName}}
											<br></span>
										{{orderConfirmation?.paymentAddress?.line1}}
										<span
											*ngIf="orderConfirmation?.paymentAddress?.line2">,&nbsp;{{orderConfirmation?.paymentAddress?.line2}}</span><br>
										<span
											*ngIf="orderConfirmation?.paymentAddress?.companyAddressTwo">{{orderConfirmation?.paymentAddress?.companyAddressTwo}}<br></span>
										{{orderConfirmation?.paymentAddress?.postalCode}}<span
											*ngIf="orderConfirmation?.paymentAddress?.town">,&nbsp;{{orderConfirmation?.paymentAddress?.town}}</span><br>
										<span
											*ngIf="orderConfirmation?.paymentAddress?.region?.name">{{orderConfirmation?.paymentAddress?.region?.name}}<br></span>
										{{orderConfirmation?.paymentAddress?.country?.name}}<br>
									</p>
								</ng-template>
							</div>
						</div>
						<div class="order-confirmation-ordertype">
							<p class="mb-0" *ngIf="orderConfirmation?.selectedOrderTypeName">
								<span class="order-confirmation-label">
									<strong>
										{{'common.checkout_orderConfirmation_order_Type'|cxTranslate}}
									</strong>
								</span>
								&nbsp;&nbsp;&nbsp;&nbsp; <span class="order-confirmation-unit">
									{{orderConfirmation?.selectedOrderTypeName}}</span>
							</p>
							<p class="mb-0" *ngIf="orderConfirmation?.currentCarrierType">
								<span class="order-confirmation-label">
									<strong class="customer-id">
										{{ "common.checkout_page_summary_final_review_carrierSelection" | cxTranslate }}
									</strong>
								</span>
								&nbsp;&nbsp;&nbsp;&nbsp; <span class="order-confirmation-unit">{{
									orderConfirmation?.currentCarrierType }}</span><br />

							</p>
							<p class="mb-0" *ngIf="orderConfirmation?.currentCarrierNumber &&
							orderConfirmation?.currentCarrierNumber.trim().length>0">
								<span class="order-confirmation-label">
									<strong>{{'common.choose_delivery_carrier_account_number'|cxTranslate}}:</strong>
								</span>
								&nbsp;&nbsp;&nbsp;&nbsp; <span class="order-confirmation-unit">
									{{orderConfirmation?.currentCarrierNumber}}</span>
							</p>
							<p class="mb-0" *ngIf="orderConfirmation?.currentDeliveryType">
								<span class="order-confirmation-label">
									<strong>
										{{'common.checkout_page_summary_final_review_delivery_type'|cxTranslate}}</strong></span>
								&nbsp;&nbsp;<span
									class="order-confirmation-unit">{{orderConfirmation?.currentDeliveryType}}</span>
							</p>

							<p *ngIf="orderConfirmation?.orderNote && orderConfirmation?.orderNote.trim().length>0">
								<span class="order-confirmation-label">
									<strong>
										{{'common.checkout_orderConfirmation_order_note'|cxTranslate}}</strong></span>
								&nbsp;&nbsp;<span
									class="order-confirmation-unit">{{orderConfirmation?.orderNote}}</span>
							</p>
							<p class="coffe-color fs-18" *ngIf="orderConfirmation?.emergencyNote">
								{{'orderConfirmation.emergencyNote.note.message'|cxTranslate}}</p>
						</div>
					</div>
				</div>
				<ul class="checkout-order-summary-list order-conformation-summary-list">
					<div class="mainEntryGroup" *ngFor="let entry of orderConfirmation?.entries">
						<!-- <li class="checkout-order-summary-list-items  ">
							<div class="thumb product-list-item-img">
								<a [routerLink]="{  cxRoute: 'product',params:entry?.product } | cxUrl">
									<cx-media
										[container]="entry?.product?.images['PRIMARY'] || entry?.product?.images"></cx-media>
								</a>
							</div>
							<div class="checkout-EntryNumber">
								{{entry?.updatedEntryNumber}}
							</div>
							<div class="details">
								<div class="checkout-Entryitem-block  d-flex">
									<div class="col-xs-12 col-sm-5 col-md-6">
										<div class="name">
											<a [routerLink]="{  cxRoute: 'product',params:entry?.product } | cxUrl">
												<strong class="name">{{entry?.product?.code}}</strong>
											</a>
											<span class="f-14 d-block" *ngIf="entry?.product?.typenumber">
												{{entry?.product?.typenumber}}
											</span>
										</div>
										<div class="">
											<br>
											{{entry?.product?.name}}
											<br>
										</div>
										<div class="" *ngIf="entry?.customPartNumber">
											{{'common.text_cust_part_no'|cxTranslate}}: {{entry?.customPartNumber}}
										</div>
										<div class="checkout-Entryitem-qty">
										</div>
									</div>
									<div
										class="col-xs-12 col-sm-7 col-md-6 d-flex flex-column order-confirmation-price-block">
										<div *ngIf="fleetPrideGroup">
											<span class="checkout-netprice-block" *ngIf="showNetPrice$|async">
												<span class="checkout-label-priceLabel ">
													{{'common.popup_cart_customer_price'|cxTranslate}}
												</span>
												<span class="checkout-input-price float-right">
													<strong
														*ngIf="!entry?.basePrice?.formattedValue || entry?.basePrice?.formattedValue.indexOf('-') > -1 ; else netPrice">
														{{'common.basket_page_poa'|cxTranslate}}
													</strong>
													<ng-template
														#netPrice>{{entry?.basePrice?.formattedValue}}&nbsp;
														{{entry?.basePrice?.currencyIso}}
													</ng-template>
												</span>
											</span>
											<p class="checkout-netprice-block  " *ngIf="showCorePrice$|async">
												<span
													class="checkout-label-priceLabel">{{'common.basket_page_coredeposit'|cxTranslate}}&nbsp;&nbsp;</span>
												<span class="checkout-input-price float-right">
													<strong
														*ngIf="!entry?.surcharge?.formattedValue || entry?.surcharge?.formattedValue.indexOf('-') > -1 ; else corePrice">
														{{'common.basket_page_poa'|cxTranslate}}
													</strong>
													<ng-template
														#corePrice>{{entry?.surcharge?.formattedValue}}&nbsp;
														{{entry?.surcharge?.currencyIso}}
													</ng-template>
												</span>
											</p>
										</div>
									</div>
								</div>
								<div class="checkout-required-block">
									<div class="del-quantity">
										<div class="qty">
											<span>{{'common.product_detail_quantity'|cxTranslate}}:
											</span>{{entry?.formattedQuantity}}
										</div>
									</div>
									<div class="checkout-requiredDeliveryDate">
										{{'common.cart_page_reqdelivery'|cxTranslate}} :&nbsp;
										{{entry?.requestedDeliveryDate }}
									</div>
									<div class="checkout-estimateDeliveryDate " *ngIf="(entry?.updateable)">
										<span class="f-13"> {{'common.cart_page_estdelivery'|cxTranslate}}
											:</span>
										<span class="f-14" *ngIf="!entry.estimatedDeliveryDate"
											class="checkout-estimate-empty">{{'common.checkout_estimateDeliveryDate_empty'|cxTranslate}}
										</span>
										<span class="f-14" *ngIf="entry.estimatedDeliveryDate"
											class="checkout-estimate-empty">{{entry?.estimatedDeliveryDate}}
										</span>
									</div>
								</div>
							</div>
						</li> -->
						<!-- sales bomb start -->
						<ng-container *ngIf="entry.associatedEntries && entry.posType=='KH'">
							<mat-expansion-panel hideToggle (opened)="panelOpenState = true"
								(closed)="panelOpenState = false">
								<mat-expansion-panel-header [collapsedHeight]="'190px'" [expandedHeight]="'190px'">

									<mat-panel-title class="d-flex flex-column">
										<span class="show-more" *ngIf="!panelOpenState">
											<i
												class="fa-solid fa-circle-plus"></i>&nbsp;{{'common.review_show_more'|cxTranslate}}
										</span>
										<span class="show-more" *ngIf="panelOpenState">
											<i
												class="fa-solid fa-circle-minus"></i>&nbsp;{{'common.review_show_less'|cxTranslate}}
										</span>

										<li class="checkout-order-summary-list-items">
											<div class="thumb product-list-item-img">
												<a [routerLink]="{ cxRoute:'product', params : entry?.product} | cxUrl">
													<cx-media
														[container]="entry?.product?.images?.['PRIMARY'] || entry?.product?.images"></cx-media>
												</a>

											</div>
											<div class="checkout-EntryNumber">
												{{entry?.updatedEntryNumber}}
											</div>
											<div class="details">
												<div class="checkout-Entryitem-block  d-flex">
													<div class="col-xs-12 col-sm-5 col-md-6 order-summary-zero-space">
														<div>
															<a
																[routerLink]="{ cxRoute:'product', params : entry?.product} | cxUrl">
																<strong class="name">{{entry?.product?.code}}</strong>
															</a>
															<span class="d-block" *ngIf="entry?.product?.typenumber">
																{{entry?.product?.typenumber}}
															</span>
														</div>

														<div class="">
															{{entry?.product?.name}}
														</div>
														<div class="" *ngIf="entry?.customPartNumber">
															{{'common.text_cust_part_no'|cxTranslate}}:
															{{entry?.customPartNumber}}
														</div>
														<div class="checkout-Entryitem-qty">
														</div>
													</div>
													<div class="col-xs-12 col-sm-7 col-md-6
														   d-flex flex-column
															  order-confirmation-price-block">
														<span class="checkout-listprice-block f-14 "
															*ngIf="showListPrice$|async">
															<span class="checkout-label-priceLabel ">
																{{'common.basket_page_listprice'|cxTranslate}}:
															</span>
															<span class="checkout-input-price float-right">
																<strong
																	*ngIf="!entry?.listPrice?.formattedValue || entry?.listPrice?.formattedValue.indexOf('-') > -1 ; else listPrice">{{'common.basket_page_poa'|cxTranslate}}</strong>
																<ng-template
																	#listPrice><strong>{{entry?.listPrice?.formattedValue}}&nbsp;{{entry?.listPrice?.currencyIso}}</strong></ng-template>
															</span>
														</span>
														<span class="checkout-netprice-block f-14"
															*ngIf="showNetPrice$|async">
															<span class="checkout-label-priceLabel ">
																{{'common.basket_page_netprice'|cxTranslate}}:
															</span>
															<span class="checkout-input-price float-right">
																<strong
																	*ngIf="!entry?.basePrice?.formattedValue || entry?.basePrice?.formattedValue.indexOf('-') > -1; else netPrice">
																	{{'common.basket_page_poa'|cxTranslate}}
																</strong>
																<ng-template #netPrice>
																	<strong>
																		{{entry?.basePrice?.formattedValue}}&nbsp;{{entry?.basePrice?.currencyIso}}
																	</strong>
																</ng-template>
															</span>
														</span>
													</div>
												</div>

												<div class="checkout-required-block d-flex align-items-center">
													<div class="del-quantity">
														{{'common.basket_page_emea_orderQty'|cxTranslate}} : <span>
															{{entry?.formattedQuantity}}</span>
													</div>
													<div class="checkout-requiredDeliveryDate ">
														<span class="f-13">
															{{'common.cart_page_reqdelivery'|cxTranslate}}
															: </span><span
															class="f-13">{{entry?.requestedDeliveryDate}}</span>
													</div>
													<div class="checkout-estimateDeliveryDate "
														*ngIf="(entry?.updateable)">
														<span class="f-13">
															{{'common.cart_page_estdelivery'|cxTranslate}}
															:</span>
														<span class="f-14" *ngIf="!entry.estimatedDeliveryDate"
															class="checkout-estimate-empty">{{'common.checkout_estimateDeliveryDate_empty'|cxTranslate}}
														</span>
														<span class="f-14" *ngIf="entry.estimatedDeliveryDate"
															class="checkout-estimate-empty">{{entry?.estimatedDeliveryDate}}
														</span>


													</div>
													<ng-template #closeit></ng-template>
												</div>
											</div>
										</li>
									</mat-panel-title>
								</mat-expansion-panel-header>

								<li class="checkout-order-summary-list-items"
									*ngFor="let item of entry.associatedEntries">

									<div class="thumb product-list-item-img">
										<a [routerLink]="{ cxRoute:'product', params : item?.product} | cxUrl">
											<cx-media
												[container]="item?.product?.images && item?.product?.images?.['PRIMARY'] || item?.product?.images"></cx-media>
										</a>
									</div>
									<div class="checkout-EntryNumber">
										{{item?.updatedEntryNumber}}
									</div>
									<div class="details">
										<div class="checkout-Entryitem-block  d-flex">
											<div class="col-xs-12 col-sm-5 col-md-6 order-summary-zero-space">
												<div>
													<a
														[routerLink]="{ cxRoute:'product', params : item?.product} | cxUrl">
														<strong class="name">{{item?.product?.code}}</strong>
													</a>
													<span class="d-block" *ngIf="entry?.product?.typenumber">
														{{entry?.product?.typenumber}}
													</span>
												</div>
												<div class="">
													{{item?.product?.name}}
												</div>
												<div class="checkout-Entryitem-qty">
												</div>
											</div>
											<div class="col-xs-12 col-sm-7 col-md-6
													   d-flex flex-column
														  order-confirmation-price-block">

												<span class="checkout-netprice-block f-14 "
													*ngIf="showCorePrice$|async">
													<span
														class="checkout-label-priceLabel">{{'common.basket_page_coredeposit'|cxTranslate}}:&nbsp;&nbsp;</span>
													<span class="checkout-input-price float-right">
														<strong
															*ngIf="!item?.surcharge?.formattedValue ||item?.surcharge?.formattedValue.indexOf('-') > -1 ; else corePrice">
															{{'common.basket_page_poa'|cxTranslate}}
														</strong>
														<ng-template #corePrice>
															<strong>
																{{item?.surcharge?.formattedValue}}&nbsp;{{item?.surcharge?.currencyIso}}
															</strong>
														</ng-template>
													</span>
												</span>
											</div>
										</div>

										<div class="checkout-required-block d-flex align-items-center sales-bomb-body">
											<div class="del-quantity">
												{{'common.basket_page_emea_orderQty'|cxTranslate}} : <span>
													{{item?.formattedQuantity}}</span>
											</div>

											<ng-template #closeit></ng-template>
										</div>
									</div>
								</li>
							</mat-expansion-panel>
						</ng-container>
						<!-- sales bomb end -->

						<!-- Replaced By Start -->
						<ng-container *ngIf="entry.associatedEntries && entry.posType=='AH'">
							<li class="checkout-order-summary-list-items replace-by-list">
								<div class="replaced-by-top">
									<div class="thumb product-list-item-img">
										<a [routerLink]="{ cxRoute:'product', params : entry?.product} | cxUrl">
											<cx-media
												[container]="entry?.product?.images?.['PRIMARY'] || entry?.product?.images"></cx-media>
										</a>
									</div>
									<div class="checkout-EntryNumber">
										{{entry?.updatedEntryNumber}}
									</div>
									<div class="details">
										<div class="checkout-Entryitem-block  d-flex">
											<div class="col-xs-12 col-sm-5 col-md-6 order-summary-zero-space">
												<div>
													<a
														[routerLink]="{ cxRoute:'product', params : entry?.product} | cxUrl">
														<strong class="name">{{entry?.product?.code}}</strong>
													</a>
													<span class="d-block" *ngIf="entry?.product?.typenumber">
														{{entry?.product?.typenumber}}
													</span>
												</div>

												<div class="product-name">
													<p>{{entry?.product?.name}}</p>
												</div>
												<div class="" *ngIf="entry?.customPartNumber">
													{{'common.text_cust_part_no'|cxTranslate}}:
													{{entry?.customPartNumber}}
												</div>
											</div>

										</div>
										<div class="checkout-required-block d-flex align-items-center">
											<div class="del-quantity">
												{{'common.basket_page_emea_orderQty'|cxTranslate}} : <span>
													{{entry?.formattedQuantity}}</span>
											</div>
											<ng-template #closeit></ng-template>
										</div>
										<div class="replaced-by-text">
											{{'common.checkout_page_replaced'|cxTranslate}}
										</div>
									</div>
								</div>
								<ng-container *ngFor="let item of entry.associatedEntries">
									<div class="thumb product-list-item-img">
										<a [routerLink]="{ cxRoute:'product', params : item?.product} | cxUrl">
											<cx-media
												[container]="item?.product?.images && (item?.product?.images?.['PRIMARY'] || item?.product?.images)"></cx-media>
										</a>
									</div>
									<div class="checkout-EntryNumber">
										{{item?.updatedEntryNumber}}
									</div>
									<div class="checkout-Entryitem-block d-flex replaced-by-entries">
										<div class="col-xs-12 col-sm-5 col-md-6 left-align pd-0">
											<div class="replace-by-block">
												<a class="checkout_productCode"
													[routerLink]="{ cxRoute:'product', params : item?.product} | cxUrl">
													<strong class="name">{{item?.product?.code}}</strong>
												</a>
												<span class="f-14 d-block" *ngIf="entry?.product?.typenumber">
													{{entry?.product?.typenumber}}
												</span>
											</div>
											<div class="f-14 replace-by-block">
												{{item?.product?.name}}
											</div>
											<div class="checkout-Entryitem-qty">
											</div>
										</div>
										<div class="col-xs-12 col-sm-7 col-md-6
										   d-flex flex-column
											  order-confirmation-price-block">
											<span class="checkout-listprice-block f-14 " *ngIf="showListPrice$|async">
												<span class="checkout-label-priceLabel ">
													{{'common.basket_page_listprice'|cxTranslate}}:
												</span>
												<span class="checkout-input-price float-right">
													<strong
														*ngIf="!item?.listPrice?.formattedValue ||item?.listPrice?.formattedValue.indexOf('-') > -1 ; else listPrice">{{'common.basket_page_poa'|cxTranslate}}</strong>
													<ng-template
														#listPrice><strong>{{item?.listPrice?.formattedValue}}&nbsp;{{item?.listPrice?.currencyIso}}</strong></ng-template>
												</span>
											</span>
											<span class="checkout-netprice-block f-14" *ngIf="showNetPrice$|async">
												<span class="checkout-label-priceLabel ">
													{{'common.basket_page_netprice'|cxTranslate}}:
												</span>
												<span class="checkout-input-price float-right">
													<strong
														*ngIf="!item?.basePrice?.formattedValue ||item?.basePrice?.formattedValue.indexOf('-') > -1; else netPrice">
														{{'common.basket_page_poa'|cxTranslate}}
													</strong>
													<ng-template #netPrice>
														<strong>
															{{item?.basePrice?.formattedValue}}&nbsp;{{item?.basePrice?.currencyIso}}
														</strong>
													</ng-template>
												</span>
											</span>
											<span class="checkout-netprice-block f-14 " *ngIf="showCorePrice$|async">
												<span
													class="checkout-label-priceLabel">{{'common.basket_page_coredeposit'|cxTranslate}}&nbsp;&nbsp;</span>
												<span class="checkout-input-price float-right">
													<strong
														*ngIf="!item?.surcharge?.formattedValue ||item?.surcharge?.formattedValue.indexOf('-') >-1; else corePrice">
														{{'common.basket_page_poa'|cxTranslate}}
													</strong>
													<ng-template #corePrice>
														<strong>
															{{item?.surcharge?.formattedValue}}&nbsp;{{item?.surcharge?.currencyIso}}
														</strong>
													</ng-template>
												</span>
											</span>
										</div>
									</div>
									<div class="checkout-required-block d-flex align-items-center replaced-by-bottom">
										<div class="del-quantity pd_left">
											{{'common.basket_page_emea_orderQty'|cxTranslate}} : <span>
												{{item?.estimatedQuantity}}</span>
										</div>
										<div class="checkout-requiredDeliveryDate">
											<span class="f-13"> {{'common.cart_page_reqdelivery'|cxTranslate}}
												: </span><span class="f-13">{{item?.requestedDeliveryDate}}</span>
										</div>
										<div class="checkout-estimateDeliveryDate " *ngIf="(item?.updateable)">
											<span class="f-13"> {{'common.cart_page_estdelivery'|cxTranslate}} :</span>
											<span class="f-14" *ngIf="!item.estimatedDeliveryDate"
												class="checkout-estimate-empty">{{'common.checkout_estimateDeliveryDate_empty'|cxTranslate}}
											</span>
											<span class="f-14" *ngIf="item.estimatedDeliveryDate"
												class="checkout-estimate-empty">{{item?.estimatedDeliveryDate}}
											</span>

										</div>
										<ng-template #closeit></ng-template>
									</div>
								</ng-container>
							</li>
						</ng-container>
						<!-- Replaced By end -->

						<!-- split start -->
						<ng-container *ngIf="entry.associatedEntries && entry.posType=='SI'">
							<li class="checkout-order-summary-list-items">
								<div class="thumb product-list-item-img">
									<a [routerLink]="{  cxRoute: 'product',params:entry?.product } | cxUrl">
										<cx-media
											[container]="entry?.product?.images['PRIMARY'] || entry?.product?.images"></cx-media>
									</a>
								</div>
								<div class="checkout-EntryNumber">
									{{entry?.updatedEntryNumber}}
								</div>
								<div class="details">
									<div class="checkout-Entryitem-block  d-flex">
										<div class="col-xs-12 col-sm-5 col-md-6 order-summary-zero-space">
											<div>
												<a [routerLink]="{  cxRoute: 'product',params:entry?.product } | cxUrl">
													<strong class="name">{{entry?.product?.code}}</strong>
												</a>
												<span class="f-14 d-block" *ngIf="entry?.product?.typenumber">
													{{entry?.product?.typenumber}}
												</span>
											</div>
											<div class="">
												<br>
												{{entry?.product?.name}}
												<br>
											</div>
											<div class="" *ngIf="entry?.customPartNumber">
												{{'common.text_cust_part_no'|cxTranslate}}: {{entry?.customPartNumber}}
											</div>
											<div class="checkout-Entryitem-qty">
											</div>
										</div>
										<div
											class="col-xs-12 col-sm-7 col-md-6 d-flex flex-column order-confirmation-price-block">
											<div *ngIf="fleetPrideGroup">
												<span class="checkout-netprice-block" *ngIf="showNetPrice$|async">
													<span class="checkout-label-priceLabel ">
														{{'common.popup_cart_customer_price'|cxTranslate}}
													</span>
													<span class="checkout-input-price float-right">
														<strong
															*ngIf="!entry?.basePrice?.formattedValue || entry?.basePrice?.formattedValue.indexOf('-') > -1 ; else netPrice">
															{{'common.basket_page_poa'|cxTranslate}}
														</strong>
														<ng-template
															#netPrice>{{entry?.basePrice?.formattedValue}}&nbsp;
															{{entry?.basePrice?.currencyIso}}
														</ng-template>
													</span>
												</span>
												<br>
												<span class="checkout-netprice-block f-14" *ngIf="showCorePrice$|async">
													<span
														class="checkout-label-priceLabel">{{'common.basket_page_coredeposit'|cxTranslate}}&nbsp;&nbsp;</span>
													<span class="checkout-input-price float-right">
														<strong
															*ngIf="!entry?.surcharge?.formattedValue || entry?.surcharge?.formattedValue.indexOf('-') > -1 ; else corePrice">
															{{'common.basket_page_poa'|cxTranslate}}
														</strong>
														<ng-template
															#corePrice>{{entry?.surcharge?.formattedValue}}&nbsp;
															{{entry?.surcharge?.currencyIso}}
														</ng-template>
													</span>
												</span>
											</div>
										</div>
									</div>
									<div class="checkout-required-block d-flex align-items-center">
										<div class="del-quantity">
											<div class="qty">
												<span>{{'common.product_detail_quantity'|cxTranslate}}:
												</span>{{entry?.formattedQuantity}}
											</div>
										</div>
										<div class="checkout-requiredDeliveryDate">
											<span class="f-13"> {{'common.cart_page_reqdelivery'|cxTranslate}}
												: </span><span class="f-13">{{entry?.requestedDeliveryDate}}</span>
										</div>
										<!-- <div class="checkout-requiredDeliveryDate">
											{{'common.cart_page_reqdelivery'|cxTranslate}} :&nbsp;
											{{entry?.requestedDeliveryDate }}
										</div> -->
										<div class="checkout-estimateDeliveryDate">

										</div>
										<ng-template #closeit></ng-template>
									</div>
									<div class="checkout-required-block d-flex align-items-center">
										<div class="del-quantity">
											<div class="qty">
												{{'common.text_checkout_page_delivery_qty'|cxTranslate}} : <span>
													{{entry?.estimatedQuantity}}</span>
											</div>
										</div>
										<div class="checkout-estimateDeliveryDate " *ngIf="(entry?.updateable)">
											<span class="f-13"> {{'common.cart_page_estdelivery'|cxTranslate}}
												:</span>
											<span class="f-14" *ngIf="!entry.estimatedDeliveryDate"
												class="checkout-estimate-empty">{{'common.checkout_estimateDeliveryDate_empty'|cxTranslate}}
											</span>
											<span class="f-14" *ngIf="entry.estimatedDeliveryDate"
												class="checkout-estimate-empty">{{entry?.estimatedDeliveryDate}}
											</span>
										</div>
										<ng-template #closeit></ng-template>
									</div>
									<div class="checkout-required-block d-flex align-items-center"
										*ngFor="let item of entry.associatedEntries">
										<div class="del-quantity">
											<div class="qty">
												{{'common.text_checkout_page_delivery_qty'|cxTranslate}} : <span>
													{{item?.estimatedQuantity}}</span>
											</div>
										</div>

										<div class="checkout-estimateDeliveryDate " *ngIf="(item?.updateable)">
											<span class="f-13"> {{'common.cart_page_estdelivery'|cxTranslate}} :</span>
											<span class="f-14" *ngIf="!item?.estimatedDeliveryDate"
												class="checkout-estimate-empty">{{'common.checkout_estimateDeliveryDate_empty'|cxTranslate}}
											</span>
											<span class="f-14" *ngIf="item?.estimatedDeliveryDate"
												class="checkout-estimate-empty">{{item?.estimatedDeliveryDate}}
											</span>
										</div>
										<ng-template #closeit></ng-template>
									</div>
								</div>
							</li>
						</ng-container>
						<!-- split End -->

						<ng-container *ngIf="!entry.associatedEntries">
							<!-- <li class="checkout-order-summary-list-items  ">
								<div class="thumb product-list-item-img">
									<a [routerLink]="{ cxRoute:'product', params : entry?.product} | cxUrl">
										<cx-media
											[container]="entry?.product?.images?.['PRIMARY'] || entry?.product?.images"></cx-media>
									</a>
								</div>
								<div class="checkout-EntryNumber">
									{{entry?.updatedEntryNumber}}
								</div>
								<div class="details">
									<div class="checkout-Entryitem-block  d-flex">
										<div class="col-xs-12 col-sm-5 col-md-6 order-summary-zero-space">
											<div>
												<a [routerLink]="{ cxRoute:'product', params : entry?.product} | cxUrl">
													<strong class="name">{{entry?.product?.code}}</strong>
												</a>
												<span class="d-block" *ngIf="entry?.product?.typenumber">
													{{entry?.product?.typenumber}}
												</span>
											</div>

											<div class="">
												{{entry?.product?.name}}
											</div>
											<div class="" *ngIf="entry?.customPartNumber">
												{{'common.text_cust_part_no'|cxTranslate}}: {{entry?.customPartNumber}}
											</div>
											<div class="checkout-Entryitem-qty">
											</div>
										</div>
										<div class="col-xs-12 col-sm-7 col-md-6
												   d-flex flex-column
													  order-confirmation-price-block">
											<span class="checkout-listprice-block f-14 " *ngIf="showListPrice$|async">
												<span class="checkout-label-priceLabel ">
													{{'common.basket_page_listprice'|cxTranslate}}:
												</span>
												<span class="checkout-input-price float-right">
													<strong
														*ngIf="!entry?.listPrice?.formattedValue || entry?.listPrice?.formattedValue.indexOf('-') > -1 ; else listPrice">{{'common.basket_page_poa'|cxTranslate}}</strong>
													<ng-template
														#listPrice><strong>{{entry?.listPrice?.formattedValue}}&nbsp;{{entry?.listPrice?.currencyIso}}</strong></ng-template>
												</span>
											</span>
											<br>
											<span class="checkout-netprice-block f-14" *ngIf="showNetPrice$|async">
												<span class="checkout-label-priceLabel ">
													{{'common.basket_page_netprice'|cxTranslate}}:
												</span>
												<span class="checkout-input-price float-right">
													<strong
														*ngIf="!entry?.basePrice?.formattedValue || entry?.basePrice?.formattedValue.indexOf('-') > -1 ; else netPrice">
														{{'common.basket_page_poa'|cxTranslate}}
													</strong>
													<ng-template #netPrice>
														<strong>
															{{entry?.basePrice?.formattedValue}}&nbsp;{{entry?.basePrice?.currencyIso}}
														</strong>
													</ng-template>
												</span>
											</span>
											<span class="checkout-netprice-block f-14 " *ngIf="showCorePrice$|async">
												<span
													class="checkout-label-priceLabel">{{'common.basket_page_coredeposit'|cxTranslate}}:&nbsp;&nbsp;</span>
												<span class="checkout-input-price float-right">
													<strong
														*ngIf="!entry?.surcharge?.formattedValue ; else corePrice">
														{{'common.basket_page_poa'|cxTranslate}}
													</strong>
													<ng-template #corePrice>
														<strong>
															{{entry?.surcharge?.formattedValue}}&nbsp;{{entry?.surcharge?.currencyIso}}
														</strong>
													</ng-template>
												</span>
											</span>
										</div>
									</div>
									<div class="checkout-required-block d-flex align-items-center">
										<div class="del-quantity">
											<div class="qty">
											{{'common.basket_page_emea_orderQty'|cxTranslate}} : <span>
												{{entry?.formattedQuantity}}</span>
											</div>
										</div>
										<div class="checkout-requiredDeliveryDate ">
											<span class="f-13"> {{'common.cart_page_reqdelivery'|cxTranslate}}
												: </span><span class="f-13">{{entry?.requestedDeliveryDate}}</span>
										</div>
										<div class="checkout-estimateDeliveryDate " *ngIf="(entry?.updateable)">
											<span class="f-13"> {{'common.cart_page_estdelivery'|cxTranslate}} :</span>
											<span class="f-14" *ngIf="!entry?.estimatedDeliveryDate"
												class="checkout-estimate-empty">{{'common.checkout_estimateDeliveryDate_empty'|cxTranslate}}
											</span>
											<span class="f-14" *ngIf="entry?.estimatedDeliveryDate"
												class="checkout-estimate-empty">{{entry?.estimatedDeliveryDate}}
											</span>

										</div>
										<ng-template #closeit></ng-template>
									</div>
								</div>

							</li> -->
							<li class="checkout-order-summary-list-items  ">
								<div class="thumb product-list-item-img">
									<a [routerLink]="{  cxRoute: 'product',params:entry?.product } | cxUrl">
										<cx-media
											[container]="entry?.product?.images['PRIMARY'] || entry?.product?.images"></cx-media>
									</a>
								</div>
								<div class="checkout-EntryNumber">
									{{entry?.updatedEntryNumber}}
								</div>
								<div class="details">
									<div class="checkout-Entryitem-block  d-flex">
										<div class="col-xs-12 col-sm-5 col-md-6">
											<div class="name">
												<a [routerLink]="{  cxRoute: 'product',params:entry?.product } | cxUrl">
													<strong class="name">{{entry?.product?.code}}</strong>
												</a>
												<span class="f-14 d-block" *ngIf="entry?.product?.typenumber">
													{{entry?.product?.typenumber}}
												</span>
											</div>
											<div class="">
												<br>
												{{entry?.product?.name}}
												<br>
											</div>
											<div class="" *ngIf="entry?.customPartNumber">
												{{'common.text_cust_part_no'|cxTranslate}}: {{entry?.customPartNumber}}
											</div>
											<div class="checkout-Entryitem-qty">
											</div>
										</div>
										<div
											class="col-xs-12 col-sm-7 col-md-6 d-flex flex-column order-confirmation-price-block">
											<div *ngIf="fleetPrideGroup">
												<span class="checkout-netprice-block" *ngIf="showNetPrice$|async">
													<span class="checkout-label-priceLabel ">
														{{'common.popup_cart_customer_price'|cxTranslate}}
													</span>
													<span class="checkout-input-price float-right">
														<strong
															*ngIf="!entry?.basePrice?.formattedValue || entry?.basePrice?.formattedValue.indexOf('-') > -1 ; else netPrice">
															{{'common.basket_page_poa'|cxTranslate}}
														</strong>
														<ng-template
															#netPrice>{{entry?.basePrice?.formattedValue}}&nbsp;
															{{entry?.basePrice?.currencyIso}}
														</ng-template>
													</span>
												</span>
												<p class="checkout-netprice-block  " *ngIf="showCorePrice$|async">
													<span
														class="checkout-label-priceLabel">{{'common.basket_page_coredeposit'|cxTranslate}}&nbsp;&nbsp;</span>
													<span class="checkout-input-price float-right">
														<strong
															*ngIf="!entry?.surcharge?.formattedValue || entry?.surcharge?.formattedValue.indexOf('-') > -1 ; else corePrice">
															{{'common.basket_page_poa'|cxTranslate}}
														</strong>
														<ng-template
															#corePrice>{{entry?.surcharge?.formattedValue}}&nbsp;
															{{entry?.surcharge?.currencyIso}}
														</ng-template>
													</span>
												</p>
											</div>
										</div>
									</div>
									<div class="checkout-required-block">
										<div class="del-quantity">
											<div class="qty">
												<span>{{'common.product_detail_quantity'|cxTranslate}}:
												</span>{{entry?.formattedQuantity}}
											</div>
										</div>
										<div class="checkout-requiredDeliveryDate">
											{{'common.cart_page_reqdelivery'|cxTranslate}} :&nbsp;
											{{entry?.requestedDeliveryDate }}
										</div>
										<div class="checkout-estimateDeliveryDate " *ngIf="(entry?.updateable)">
											<span class="f-13"> {{'common.cart_page_estdelivery'|cxTranslate}}
												:</span>
											<span class="f-14" *ngIf="!entry.estimatedDeliveryDate"
												class="checkout-estimate-empty">{{'common.checkout_estimateDeliveryDate_empty'|cxTranslate}}
											</span>
											<span class="f-14" *ngIf="entry.estimatedDeliveryDate"
												class="checkout-estimate-empty">{{entry?.estimatedDeliveryDate}}
											</span>
										</div>
									</div>
								</div>
							</li>
						</ng-container>

					</div>
				</ul>
			</div>
		</div>
		<div class="account-orderdetail order-confirmation-orderdetails mb-3">
			<div class="account-orderdetail__footer">
				<div class="row">
					<div class="col-sm-6 col-md-7 col-lg-7">
					</div>
					<div class="col-sm-6 col-md-5 col-lg-5">
						<div class="orderTotal order-confirmation-orderTotal">
							<div class="row" *ngIf="showNetPrice$|async">
								<div class="col-xs-7 col-sm-7 order-confirmation-orderTotal-label"
									*ngIf="fleetPrideGroup">
									{{'common.order_form_subtotal'|cxTranslate}}:</div>
								<div class="col-xs-5 col-sm-5 order-confirmation-subTotal-Unit" *ngIf="fleetPrideGroup">

									<div class="text-right"
										*ngIf=" (orderConfirmation?.subTotal?.formattedValue.indexOf('-') < 0) &&
                                (orderConfirmation?.minOrderCharge?.formattedValue.indexOf('-')<0) &&
                               (orderConfirmation.totalPriceWithTax?.formattedValue.indexOf('-') < 0);else nosubTotalPrice ">
										{{orderConfirmation?.subTotal?.formattedValue}}&nbsp;{{orderConfirmation?.subTotal?.currencyIso}}
									</div>
									<ng-template #nosubTotalPrice>
										<div class="text-right">{{'common.basket_page_poa'|cxTranslate}}</div>
									</ng-template>
								</div>
								<div class="col-xs-7 col-sm-7 order-confirmation-orderTotal-label"
									*ngIf="orderConfirmation?.minOrderCharge?.value??0 >0">
									<div>
										{{'common.text_account_order_min_NA'|cxTranslate}}</div>
								</div>
								<div class="col-xs-5 col-sm-5 order-confirmation-subTotal-Unit"
									*ngIf="orderConfirmation?.minOrderCharge?.value??0 >0">

									<div class="text-right"
										*ngIf=" (orderConfirmation?.subTotal?.formattedValue.indexOf('-') < 0) &&
                                (orderConfirmation?.minOrderCharge?.formattedValue.indexOf('-')<0) &&
                               (orderConfirmation.totalPriceWithTax?.formattedValue.indexOf('-') < 0);else nominOrderChargePrice ">
										{{orderConfirmation?.minOrderCharge?.formattedValue}}&nbsp;
										{{orderConfirmation?.minOrderCharge?.currencyIso}}
									</div>
									<ng-template #nominOrderChargePrice>
										<div class="text-right">{{'common.basket_page_poa'|cxTranslate}}</div>
									</ng-template>
								</div>
								<div class="col-xs-12 col-sm-12 row border-top my-2"></div>
								<div class="col-xs-7 col-sm-7 order-confirmation-orderTotal-label-Total">
									<div class="totals" *ngIf="fleetPrideGroup">
										{{'common.basket_page_totals_total'|cxTranslate}}</div>
								</div>
								<div class="col-xs-5 col-sm-5 order-confirmation-subTotal-Unit-Total">

									<div class="text-right totals"
										*ngIf="fleetPrideGroup && (orderConfirmation?.subTotal?.formattedValue.indexOf('-') < 0) &&
                                (orderConfirmation?.minOrderCharge?.formattedValue.indexOf('-')<0) &&
                               (orderConfirmation.totalPriceWithTax?.formattedValue.indexOf('-') < 0);else nototalPrice ">
										{{orderConfirmation?.totalPriceWithTax?.formattedValue}}&nbsp;
										{{orderConfirmation?.totalPriceWithTax?.currencyIso}}
									</div>
									<ng-template #nototalPrice>
										<div class="text-right totals">{{'common.basket_page_poa'|cxTranslate}}</div>
									</ng-template>
								</div>

							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="float-right col-xs-12 col-sm-6 col-md-5 col-lg-4 my-3">
			<div class="float-right">
				<button (click)="continueShopping()" class="btn button-launch">
					{{'common.general_continue_shopping'|cxTranslate}}</button>
			</div>
		</div>
	</div>
</ng-container>
<ng-container *ngIf="isMobile">
	<div class="p-2">
		<div>
			<h2 class="order-confirmtitle">{{'common.checkout_orderConfirmation_title'|cxTranslate}}</h2>
			<p class="ordertoppara">
				<strong>
					{{'common.checkout_orderConfirmation_thankYouForOrder_emea'|cxTranslate}}</strong>
			</p>
		</div>
		<div class="order-confirmation-summary">
			<div class="order-confirmation-summary-title">
				{{'common.checkout_orderConfirmation_Summary_title'|cxTranslate}}</div>
			<div class="order-confirmation-summary-body">
				<div class="order-confirmation-top-category ">
					<div class="col-xs-12 col-sm-4  order-date-order">
						<p class="mb-0">
							<strong>
								{{'common.text_account_table_header_date'|cxTranslate}}:&nbsp;
							</strong>&nbsp;{{orderConfirmation?.kbcreated}}
						</p>
					</div>
					<div class="col-xs-12 col-sm-4  order-con-order">
						<p class="mb-0">
							<strong>{{'common.checkout_orderConfirmation_Order_ID'|cxTranslate}}</strong>
							<span>&nbsp;&nbsp;{{orderConfirmation?.code}}</span>
						</p>
					</div>
					<div class="col-xs-12 col-sm-4  order-po-order">
						<p class="mb-0">
							<strong>
								{{'common.order_track_my_status_po'|cxTranslate}}</strong>
							<span>&nbsp;&nbsp;&nbsp;&nbsp;{{ orderConfirmation?.purchaseOrderNumber }}</span>
						</p>
					</div>
				</div>
				<div class="order-confirmation-middle-category">
					<div class="col-xs-12 col-sm-12  order-con-customerID">
						<p class="oc-title">
							<strong>{{'common.checkout_orderConfirmation_Customer_ID'|cxTranslate}}</strong>
						</p>
						<p>{{orderConfirmation?.user?.name}}</p>
						<p class="email">
							{{orderConfirmation?.user?.uid}}
						</p>
						<ng-container>
							<p class="df-customerID">
								{{orderConfirmation?.currentB2BUnit?.addresses[0]?.sapCustomerID}}<br>
								{{orderConfirmation?.currentB2BUnit?.name}}<br>
								{{orderConfirmation?.currentB2BUnit?.addresses[0]?.line1}}<span
									*ngIf="orderConfirmation?.currentB2BUnit?.addresses[0]?.line2">,
									{{orderConfirmation?.currentB2BUnit?.addresses[0]?.line2}}</span><br>

								<span
									*ngIf="orderConfirmation?.currentB2BUnit?.addresses[0]?.companyAddressTwo">{{orderConfirmation?.currentB2BUnit?.addresses[0]?.companyAddressTwo}}<br></span>
								{{orderConfirmation?.currentB2BUnit?.addresses[0]?.postalCode}}<span
									*ngIf="orderConfirmation?.currentB2BUnit?.addresses[0]?.town">,&nbsp;{{orderConfirmation?.currentB2BUnit?.addresses[0]?.town}}</span><br>
								<span
									*ngIf="orderConfirmation?.currentB2BUnit?.addresses[0]?.region?.name">{{orderConfirmation?.currentB2BUnit?.addresses[0]?.region?.name}}<br></span>
								{{orderConfirmation?.currentB2BUnit?.addresses[0]?.country?.name}}<br><br>
							</p>
						</ng-container>
						<div class="order-confirmation-ordertype">
							<p class="mb-0" *ngIf="orderConfirmation?.selectedOrderTypeName">
								<span class="order-confirmation-label">
									<strong>
										{{'common.checkout_orderConfirmation_order_Type'|cxTranslate}}
									</strong>
								</span>
								&nbsp;&nbsp;&nbsp;&nbsp; <span class="order-confirmation-unit">
									{{orderConfirmation?.selectedOrderTypeName}}</span>
							</p>
							<p class="mb-0" *ngIf="orderConfirmation?.currentCarrierType">
								<span class="order-confirmation-label">
									<strong class="customer-id">
										{{ "common.checkout_page_summary_final_review_carrierSelection" | cxTranslate }}
									</strong>
								</span>
								&nbsp;&nbsp;&nbsp;&nbsp; <span class="order-confirmation-unit">{{
									orderConfirmation?.currentCarrierType }}</span><br />

							</p>

							<p class="mb-0" *ngIf="orderConfirmation?.currentCarrierNumber &&
							orderConfirmation?.currentCarrierNumber.trim().length>0">
								<span class="order-confirmation-label">
									<strong>{{'common.choose_delivery_carrier_account_number'|cxTranslate}}:</strong>
								</span>
								&nbsp;&nbsp;&nbsp;&nbsp; <span class="order-confirmation-unit">
									{{orderConfirmation?.currentCarrierNumber}}</span>
							</p>
							<p class="mb-0" *ngIf="orderConfirmation?.currentDeliveryType">
								<span class="order-confirmation-label">
									<strong>
										{{'common.checkout_page_summary_final_review_delivery_type'|cxTranslate}}</strong></span>
								&nbsp;&nbsp;<span
									class="order-confirmation-unit">{{orderConfirmation?.currentDeliveryType}}</span>
							</p>

							<p *ngIf="orderConfirmation?.orderNote && orderConfirmation?.orderNote.trim().length>0">
								<span class="order-confirmation-label">
									<strong>
										{{'common.checkout_orderConfirmation_order_note'|cxTranslate}}</strong></span>
								&nbsp;&nbsp;<span
									class="order-confirmation-unit">{{orderConfirmation?.orderNote}}</span>
							</p>
						</div>
					</div>
					<div class="col-xs-12 col-sm-6  order-con-Shipping-Address">
						<p class="oc-title">
							<strong>{{'common.checkout_summary_shippingAddress'|cxTranslate}}</strong>
						</p>
						<span>{{orderConfirmation?.deliveryAddress?.sapCustomerID}}</span>
						<p>
							<span
								*ngIf="orderConfirmation?.deliveryAddress?.companyName">{{orderConfirmation?.deliveryAddress?.companyName}}
								<br></span>
							{{orderConfirmation?.deliveryAddress?.line1}}
							<span
								*ngIf="orderConfirmation?.deliveryAddress?.line2">,&nbsp;{{orderConfirmation?.deliveryAddress?.line2}}<br></span>
							<span
								*ngIf="orderConfirmation?.deliveryAddress?.companyAddressTwo">{{orderConfirmation?.deliveryAddress?.companyAddressTwo}}<br></span>
							{{orderConfirmation?.deliveryAddress?.postalCode}}<span
								*ngIf="orderConfirmation?.deliveryAddress?.town">,&nbsp;{{orderConfirmation?.deliveryAddress?.town}}</span><br>
							<span
								*ngIf="orderConfirmation?.deliveryAddress?.region?.name">{{orderConfirmation?.deliveryAddress?.region?.name}}<br></span>
							{{orderConfirmation?.deliveryAddress?.country?.name}}<br>
						</p><br>
					</div>
					<div class="col-xs-12 col-sm-6  order-con-Billing-Address">
						<p class="oc-title">
							<strong>{{'common.checkout_orderConfirmation_Billing_Address'|cxTranslate}}</strong>
						</p>
						<ng-container *ngIf="orderConfirmation?.defaultBilling ; else mobpaymentAddress">
							<span>{{orderConfirmation?.defaultBilling?.sapCustomerID}}</span>

							<p>
								<span
									*ngIf="orderConfirmation?.defaultBilling?.companyName">{{orderConfirmation?.defaultBilling?.companyName}}
									<br></span>
								{{orderConfirmation?.defaultBilling?.line1}}
								<span
									*ngIf="orderConfirmation?.defaultBilling?.line2">,&nbsp;{{orderConfirmation?.defaultBilling?.line2}}<br></span>
								<span
									*ngIf="orderConfirmation?.defaultBilling?.companyAddressTwo">{{orderConfirmation?.defaultBilling?.companyAddressTwo}}<br></span>
								{{orderConfirmation?.defaultBilling?.postalCode}}<span
									*ngIf="orderConfirmation?.defaultBilling?.town">,&nbsp;{{orderConfirmation?.defaultBilling?.town}}</span><br>
								<span
									*ngIf="orderConfirmation?.defaultBilling?.region?.name">{{orderConfirmation?.defaultBilling?.region?.name}}</span>
								{{orderConfirmation?.defaultBilling?.country?.name}}<br>
							</p>
						</ng-container>
						<ng-template #mobpaymentAddress>
							<span>{{orderConfirmation?.paymentAddress?.sapCustomerID}}</span>

							<p>
								<span
									*ngIf="orderConfirmation?.paymentAddress?.companyName">{{orderConfirmation?.paymentAddress?.companyName}}
									<br></span>
								{{orderConfirmation?.paymentAddress?.line1}}
								<span
									*ngIf="orderConfirmation?.paymentAddress?.line2">,&nbsp;{{orderConfirmation?.paymentAddress?.line2}}<br></span>
								<span
									*ngIf="orderConfirmation?.paymentAddress?.companyAddressTwo">{{orderConfirmation?.paymentAddress?.companyAddressTwo}}<br></span>
								{{orderConfirmation?.paymentAddress?.postalCode}}<span
									*ngIf="orderConfirmation?.paymentAddress?.town">,&nbsp;{{orderConfirmation?.paymentAddress?.town}}</span><br>
								<span
									*ngIf="orderConfirmation?.paymentAddress?.region?.name">{{orderConfirmation?.paymentAddress?.region?.name}}<br></span>
								{{orderConfirmation?.paymentAddress?.country?.name}}<br>
							</p>
						</ng-template>
					</div>
					<p class="coffe-color mt-2 fs-18 pl-3" *ngIf="orderConfirmation?.emergencyNote">
						{{'orderConfirmation.emergencyNote.note.message'|cxTranslate}}</p>
				</div>
			</div>
		</div>
		<div class=" order-conformation-summary-list">
			<div class="mainEntryGroup" *ngFor="let entry of orderConfirmation?.entries">
				<!-- <div class="checkout-order-summary-list-items">
					<div class="thumb product-list-item-img">
						<a [routerLink]="{  cxRoute: 'product',params:entry?.product } | cxUrl">
							<cx-media
								[container]="entry?.product?.images['PRIMARY'] || entry?.product?.images"></cx-media>
						</a>
					</div>
					<div class="checkout-EntryNumber">
						{{entry?.updatedEntryNumber}}
					</div>
					<div class="details">
						<div class="checkout-Entryitem-block  d-flex">
							<div class="col-xs-12 col-sm-12 ">
								<div class="name">
									<a [routerLink]="{  cxRoute: 'product',params:entry?.product } | cxUrl">
										<strong class="name">{{entry?.product?.code}}</strong>
									</a>
									<span class="f-14 d-block" *ngIf="entry?.product?.typenumber">
										{{entry?.product?.typenumber}}
									</span>
								</div>
								<div class="">
									<br>
									{{entry?.product?.name}}
									<br>
								</div>
								<div class="" *ngIf="entry?.customPartNumber">
									{{'common.text_cust_part_no'|cxTranslate}}: {{entry?.customPartNumber}}
								</div>
								<div class="checkout-Entryitem-qty">
								</div>
							</div>
						</div>
						<div class="col-xs-12 col-sm-12 d-flex flex-column order-confirmation-price-block">
							<span *ngIf="fleetPrideGroup">
								<span class="checkout-netprice-block" *ngIf="showNetPrice$|async">
									<span class="checkout-label-priceLabel ">
										{{'common.popup_cart_customer_price'|cxTranslate}}
									</span>
									<span class="checkout-input-price float-right">
										<strong
											*ngIf="!entry?.product?.customerPrice?.formattedValue || entry?.product?.customerPrice?.formattedValue.indexOf('-') > -1; else netPrice">
											{{'common.basket_page_poa'|cxTranslate}}
										</strong>
										<ng-template #netPrice>
											{{entry?.product?.customerPrice?.formattedValue}}&nbsp;
											{{entry?.product?.customerPrice?.currencyIso}}
										</ng-template>
									</span>
								</span>
								<p class="checkout-netprice-block  " *ngIf="showCorePrice$|async">
									<span class="checkout-label-priceLabel">
										{{'common.basket_page_coredeposit'|cxTranslate}}&nbsp;&nbsp;
									</span>
									<span class="checkout-input-price float-right">
										<strong
											*ngIf="!entry?.surcharge?.formattedValue || entry?.surcharge?.formattedValue.indexOf('-') > -1 ; else corePrice">
											{{'common.basket_page_poa'|cxTranslate}}
										</strong>
										<ng-template #corePrice>
											{{entry?.surcharge?.formattedValue}}&nbsp;
											{{entry?.surcharge?.currencyIso}}
										</ng-template>
									</span>
								</p>
							</span>
						</div>
						<div class="del-quantity pl-3 ">
							<div class="mob-qty ">
								{{'common.product_detail_quantity'|cxTranslate}}: {{entry?.formattedQuantity}}
							</div>
							<div class="checkout-requiredDeliveryDate">
								{{'common.cart_page_reqdelivery'|cxTranslate}} :
								{{entry?.requestedDeliveryDate}}
							</div>
							<div class="checkout-estimateDeliveryDate " *ngIf="(entry?.updateable)">
								<span class="f-13"> {{'common.cart_page_estdelivery'|cxTranslate}}
									:</span>
								<span class="f-14" *ngIf="!entry.estimatedDeliveryDate"
									class="checkout-estimate-empty">{{'common.checkout_estimateDeliveryDate_empty'|cxTranslate}}
								</span>
								<span class="f-14" *ngIf="entry.estimatedDeliveryDate"
									class="checkout-estimate-empty">{{entry?.estimatedDeliveryDate}}
								</span>
							</div>
						</div>
					</div>
				</div> -->

				<!-- sales bomb start -->
				<ng-container *ngIf="entry.associatedEntries && entry.posType=='KH'">
					<mat-expansion-panel hideToggle (opened)="panelOpenState = true" (closed)="panelOpenState = false">
						<mat-expansion-panel-header [collapsedHeight]="'295px'" [expandedHeight]="'295px'">

							<mat-panel-title class="d-flex flex-column">
								<span class="show-more" *ngIf="!panelOpenState">
									<i
										class="fa-solid fa-circle-plus"></i>&nbsp;{{'common.review_show_more'|cxTranslate}}
								</span>
								<span class="show-more" *ngIf="panelOpenState">
									<i
										class="fa-solid fa-circle-minus"></i>&nbsp;{{'common.review_show_less'|cxTranslate}}
								</span>

								<li class="checkout-order-summary-list-items">
									<div class="thumb product-list-item-img">
										<a [routerLink]="{ cxRoute:'product', params : entry?.product} | cxUrl">
											<cx-media
												[container]="entry?.product?.images?.['PRIMARY'] || entry?.product?.images"></cx-media>
										</a>
									</div>
									<div class="checkout-EntryNumber">
										{{entry?.updatedEntryNumber}}
									</div>
									<div class="details">
										<div class="checkout-Entryitem-block  d-flex">
											<div class="col-xs-12 col-sm-12 checkout-zero-padding">
												<div>
													<a
														[routerLink]="{ cxRoute:'product', params : entry?.product} | cxUrl">
														<strong class="name">{{entry?.product?.code}}</strong>
													</a>
												</div>

												<div class="checkout-product-name">
													{{entry?.product?.name}}
												</div>
												<div class="checkout-partnumber" *ngIf="entry?.customPartNumber">
													{{'common.text_cust_part_no'|cxTranslate}}:
													{{entry?.customPartNumber}}
												</div>
												<div class="checkout-Entryitem-qty">
												</div>
											</div>

										</div>
										<div class="col-xs-12 col-sm-12
									d-flex flex-column
									order-confirmation-price-block">
											<span class="checkout-listprice-block " *ngIf="showListPrice$|async">
												<span
													class="checkout-label-priceLabel ">{{'common.basket_page_listprice'|cxTranslate}}:</span>
												<span class="checkout-input-price float-right">
													<strong
														*ngIf="!entry?.listPrice?.formattedValue || entry?.listPrice?.formattedValue.indexOf('-') > -1 ; else listPrice">{{'common.basket_page_poa'|cxTranslate}}</strong>
													<ng-template
														#listPrice>{{entry?.listPrice?.formattedValue}}&nbsp;{{entry?.listPrice?.currencyIso}}</ng-template>
												</span>
											</span>
											<span class="checkout-netprice-block" *ngIf="showNetPrice$|async">
												<span class="checkout-label-priceLabel ">
													{{'common.basket_page_netprice'|cxTranslate}}:
												</span>
												<span class="checkout-input-price float-right">
													<strong
														*ngIf="!entry?.basePrice?.formattedValue || entry?.basePrice?.formattedValue.indexOf('-') > -1 ; else netPrice">{{'common.basket_page_poa'|cxTranslate}}</strong>
													<ng-template
														#netPrice>{{entry?.basePrice?.formattedValue}}&nbsp;{{entry?.basePrice?.currencyIso}}</ng-template>
												</span>
											</span>
											<span class="checkout-netprice-block  " *ngIf="showCorePrice$|async">
												<span
													class="checkout-label-priceLabel">{{'common.basket_page_coredeposit'|cxTranslate}}:&nbsp;&nbsp;</span>
												<span class="checkout-input-price float-right">
													<strong
														*ngIf="!entry?.surcharge?.formattedValue ; else corePrice">{{'common.basket_page_poa'|cxTranslate}}</strong>
													<ng-template
														#corePrice>{{entry?.surcharge?.formattedValue}}&nbsp;{{entry?.surcharge?.currencyIso}}</ng-template>
												</span>
											</span>
										</div>
										<div class="del-quantity f-13 ">
											<div class="mob-qty ">
												{{'common.basket_page_emea_orderQty'|cxTranslate}} :
												{{entry?.formattedQuantity}}
											</div>
											<div class="checkout-requiredDeliveryDate f-13">
												{{'common.cart_page_reqdelivery'|cxTranslate}} :
												{{entry?.requestedDeliveryDate}}
											</div>
											<div class="checkout-estimateDeliveryDate f-13"
												*ngIf="(entry?.updateable) ; else closeitmob">
												{{'common.cart_page_estdelivery'|cxTranslate}} :

												<span class="f-13" *ngIf="!entry.estimatedDeliveryDate"
													class="checkout-estimate-empty">{{'common.checkout_estimateDeliveryDate_empty'|cxTranslate}}
												</span>
												<span class="f-13" *ngIf="entry.estimatedDeliveryDate"
													class="checkout-estimate-empty">{{entry?.estimatedDeliveryDate}}
												</span>
											</div>
											<ng-template #closeitmob></ng-template>
										</div>
									</div>
								</li>
							</mat-panel-title>
						</mat-expansion-panel-header>

						<li class="checkout-order-summary-list-items" *ngFor="let item of entry.associatedEntries">

							<div class="thumb product-list-item-img">
								<a [routerLink]="{ cxRoute:'product', params : entry?.product} | cxUrl">
									<cx-media
										[container]="entry?.product?.images?.['PRIMARY'] || entry?.product?.images"></cx-media>
								</a>
							</div>
							<div class="checkout-EntryNumber">
								{{entry?.updatedEntryNumber}}
							</div>
							<div class="details">
								<div class="checkout-Entryitem-block  d-flex">
									<div class="col-xs-12 col-sm-12 checkout-zero-padding">
										<div>
											<a [routerLink]="{ cxRoute:'product', params : entry?.product} | cxUrl">
												<strong class="name">{{entry?.product?.code}}</strong>
											</a>
										</div>

										<div class="checkout-product-name">
											{{entry?.product?.name}}
										</div>
										<div class="checkout-partnumber" *ngIf="entry?.customPartNumber">
											{{'common.text_cust_part_no'|cxTranslate}}: {{entry?.customPartNumber}}
										</div>
										<div class="checkout-Entryitem-qty">
										</div>
									</div>

								</div>
								<div class="col-xs-12 col-sm-12
							d-flex flex-column
							order-confirmation-price-block">

									<span class="checkout-netprice-block  " *ngIf="showCorePrice$|async">
										<span
											class="checkout-label-priceLabel">{{'common.basket_page_coredeposit'|cxTranslate}}:&nbsp;&nbsp;</span>
										<span class="checkout-input-price float-right">
											<strong
												*ngIf="!entry?.surcharge?.formattedValue ; else corePrice">{{'common.basket_page_poa'|cxTranslate}}</strong>
											<ng-template
												#corePrice>{{entry?.surcharge?.formattedValue}}&nbsp;{{entry?.surcharge?.currencyIso}}</ng-template>
										</span>
									</span>
								</div>
								<div class="del-quantity f-13 ">
									<div class="mob-qty ">
										{{'common.basket_page_emea_orderQty'|cxTranslate}}: {{entry?.formattedQuantity}}
									</div>

									<ng-template #closeitmob></ng-template>
								</div>
							</div>
						</li>
					</mat-expansion-panel>
				</ng-container>
				<!-- sales bomb end -->


				<!-- Replaced By Start -->
				<ng-container *ngIf="entry.associatedEntries && entry.posType=='AH'">
					<li class="checkout-order-summary-list-items replace-by-list">
						<div class="replaced-by-top">
							<div class="thumb product-list-item-img">
								<a [routerLink]="{ cxRoute:'product', params : entry?.product} | cxUrl">
									<cx-media
										[container]="entry?.product?.images?.['PRIMARY'] || entry?.product?.images"></cx-media>
								</a>
							</div>
							<div class="checkout-EntryNumber">
								{{entry?.updatedEntryNumber}}
							</div>
							<div class="details">
								<div class="checkout-Entryitem-block  d-flex">
									<div class="col-xs-12 col-sm-5 col-md-6 order-summary-zero-space">
										<div>
											<a [routerLink]="{ cxRoute:'product', params : entry?.product} | cxUrl">
												<strong class="name">{{entry?.product?.code}}</strong>
											</a>
										</div>

										<div class="product-name">
											<p>{{entry?.product?.name}}</p>
										</div>
										<div class="" *ngIf="entry?.customPartNumber">
											{{'common.text_cust_part_no'|cxTranslate}}: {{entry?.customPartNumber}}
										</div>
									</div>

								</div>
								<div class="checkout-required-block d-flex align-items-center">
									<div class="del-quantity">
										{{'common.basket_page_emea_orderQty'|cxTranslate}} : <span>
											{{entry?.formattedQuantity}}</span>
									</div>
									<ng-template #closeit></ng-template>
								</div>
								<div class="replaced-by-text">
									{{'common.checkout_page_replaced'|cxTranslate}}
								</div>
							</div>
						</div>
						<ng-container *ngFor="let item of entry.associatedEntries">
							<div class="thumb product-list-item-img">
								<a [routerLink]="{ cxRoute:'product', params : item?.product} | cxUrl">
									<cx-media
										[container]="item?.product?.images && (item?.product?.images?.['PRIMARY'] || item?.product?.images)"></cx-media>
								</a>
							</div>
							<div class="checkout-EntryNumber">
								{{item?.updatedEntryNumber}}
							</div>
							<div class="checkout-Entryitem-block d-flex replaced-by-entries">
								<div class="col-xs-12 col-sm-5 col-md-6 zero-padding">
									<div class="replace-by-block">
										<a class="checkout_productCode"
											[routerLink]="{ cxRoute:'product', params : item?.product} | cxUrl">
											<strong class="name">{{item?.product?.code}}</strong>
										</a>
									</div>
									<div class="f-14">
										{{item?.product?.name}}
									</div>
									<div class="checkout-Entryitem-qty">
									</div>
								</div>
								<div class="col-xs-12 col-sm-7 col-md-6
						d-flex flex-column
							order-confirmation-price-block">
									<span class="checkout-listprice-block f-14 " *ngIf="showListPrice$|async">
										<span class="checkout-label-priceLabel ">
											{{'common.basket_page_listprice'|cxTranslate}}:
										</span>
										<span class="checkout-input-price float-right">
											<strong
												*ngIf="!item?.listPrice?.formattedValue ||item?.listPrice?.formattedValue.indexOf('-') > -1 ; else listPrice">{{'common.basket_page_poa'|cxTranslate}}</strong>
											<ng-template
												#listPrice><strong>{{item?.listPrice?.formattedValue}}&nbsp;{{item?.listPrice?.currencyIso}}</strong></ng-template>
										</span>
									</span>
									<span class="checkout-netprice-block f-14" *ngIf="showNetPrice$|async">
										<span class="checkout-label-priceLabel ">
											{{'common.basket_page_netprice'|cxTranslate}}:
										</span>
										<span class="checkout-input-price float-right">
											<strong
												*ngIf="!item?.basePrice?.formattedValue ||item?.basePrice?.formattedValue.indexOf('-') > -1 ; else netPrice">
												{{'common.basket_page_poa'|cxTranslate}}
											</strong>
											<ng-template #netPrice>
												<strong>
													{{item?.basePrice?.formattedValue}}&nbsp;{{item?.basePrice?.currencyIso}}
												</strong>
											</ng-template>
										</span>
									</span>
									<span class="checkout-netprice-block" *ngIf="showCorePrice$|async">
										<span
											class="checkout-label-priceLabel">{{'common.basket_page_coredeposit'|cxTranslate}}&nbsp;&nbsp;</span>
										<span class="checkout-input-price float-right">
											<strong
												*ngIf="!item?.surcharge?.formattedValue ||item?.surcharge?.formattedValue.indexOf('-') > -1 ; else corePrice">
												{{'common.basket_page_poa'|cxTranslate}}
											</strong>
											<ng-template #corePrice>
												<strong>
													{{item?.surcharge?.formattedValue}}&nbsp;{{item?.surcharge?.currencyIso}}
												</strong>
											</ng-template>
										</span>
									</span>
								</div>
							</div>
							<div class="checkout-required-block d-flex align-items-center replaced-by-bottom">
								<div class="del-quantity f-14">
									{{'common.basket_page_emea_orderQty'|cxTranslate}} : <span>
										{{item?.estimatedQuantity}}</span>
								</div>
								<div class="checkout-requiredDeliveryDate ">
									<span class="f-13"> {{'common.cart_page_reqdelivery'|cxTranslate}}
										: </span><span class="f-13">{{item?.requestedDeliveryDate}}</span>
								</div>
								<div class="checkout-estimateDeliveryDate " *ngIf="(item?.updateable)">
									<span class="f-13"> {{'common.cart_page_estdelivery'|cxTranslate}} :</span>
									<span class="f-14" *ngIf="!item.estimatedDeliveryDate"
										class="checkout-estimate-empty">{{'common.checkout_estimateDeliveryDate_empty'|cxTranslate}}
									</span>
									<span class="f-14" *ngIf="item.estimatedDeliveryDate"
										class="checkout-estimate-empty">{{item?.estimatedDeliveryDate}}
									</span>

								</div>
								<ng-template #closeit></ng-template>
							</div>
						</ng-container>
					</li>
				</ng-container>
				<!-- Replaced By end -->

				<!-- Split Start -->
				<ng-container *ngIf="entry.associatedEntries && entry.posType=='SI'">
					<li class="checkout-order-summary-list-items  ">
						<div class="thumb product-list-item-img">
							<a [routerLink]="{ cxRoute:'product', params : entry?.product} | cxUrl">
								<cx-media
									[container]="entry?.product?.images?.['PRIMARY'] || entry?.product?.images"></cx-media>
							</a>
						</div>
						<div class="checkout-EntryNumber">
							{{entry?.updatedEntryNumber}}
						</div>
						<div class="details">
							<div class="checkout-Entryitem-block  d-flex">
								<div class="col-xs-12 col-sm-5 col-md-6 order-summary-zero-space">
									<div>
										<a [routerLink]="{ cxRoute:'product', params : entry?.product} | cxUrl">
											<strong class="name">{{entry?.product?.code}}</strong>
										</a>
									</div>

									<div class="">
										{{entry?.product?.name}}
									</div>
									<div class="" *ngIf="entry?.customPartNumber">
										{{'common.text_cust_part_no'|cxTranslate}}: {{entry?.customPartNumber}}
									</div>
									<div class="checkout-Entryitem-qty">
									</div>
								</div>
								<div class="col-xs-12 col-sm-7 col-md-6
									d-flex flex-column
										order-confirmation-price-block">
									<span class="checkout-listprice-block f-14 " *ngIf="showListPrice$|async">
										<span class="checkout-label-priceLabel ">
											{{'common.basket_page_listprice'|cxTranslate}}:
										</span>
										<span class="checkout-input-price float-right">
											<strong
												*ngIf="!entry?.listPrice?.formattedValue || entry?.listPrice?.formattedValue.indexOf('-') > -1 ; else listPrice">{{'common.basket_page_poa'|cxTranslate}}</strong>
											<ng-template
												#listPrice><strong>{{entry?.listPrice?.formattedValue}}&nbsp;{{entry?.listPrice?.currencyIso}}</strong></ng-template>
										</span>
									</span>
									<span class="checkout-netprice-block f-14" *ngIf="showNetPrice$|async">
										<span class="checkout-label-priceLabel ">
											{{'common.basket_page_netprice'|cxTranslate}}:
										</span>
										<span class="checkout-input-price float-right">
											<strong
												*ngIf="!entry?.basePrice?.formattedValue || entry?.basePrice?.formattedValue.indexOf('-') > -1 ; else netPrice">
												{{'common.basket_page_poa'|cxTranslate}}
											</strong>
											<ng-template #netPrice>
												<strong>
													{{entry?.basePrice?.formattedValue}}&nbsp;{{entry?.basePrice?.currencyIso}}
												</strong>
											</ng-template>
										</span>
									</span>
									<span class="checkout-netprice-block f-14 " *ngIf="showCorePrice$|async">
										<span
											class="checkout-label-priceLabel">{{'common.basket_page_coredeposit'|cxTranslate}}:&nbsp;&nbsp;</span>
										<span class="checkout-input-price float-right">
											<strong *ngIf="!entry?.surcharge?.formattedValue ; else corePrice">
												{{'common.basket_page_poa'|cxTranslate}}
											</strong>
											<ng-template #corePrice>
												<strong>
													{{entry?.surcharge?.formattedValue}}&nbsp;{{entry?.surcharge?.currencyIso}}
												</strong>
											</ng-template>
										</span>
									</span>
								</div>
							</div>
							<div class="checkout-required-block d-flex align-items-center">
								<div class="del-quantity">
									{{'common.basket_page_emea_orderQty'|cxTranslate}} : {{entry?.quantity}}
								</div>
								<div class="checkout-requiredDeliveryDate ">
									<span class="f-13"> {{'common.cart_page_reqdelivery'|cxTranslate}}
										: {{entry?.requestedDeliveryDate}}</span>
								</div>
								<div class="checkout-estimateDeliveryDate"></div>
								<ng-template #closeit></ng-template>
							</div>
							<div class="checkout-required-block d-flex align-items-center">
								<div class="del-quantity">
									{{'common.basket_page_emea_orderQty'|cxTranslate}}:
									{{entry?.estimatedQuantity}}
								</div>

								<div class="checkout-estimateDeliveryDate " *ngIf="(entry?.updateable)">
									<span class="f-13"> {{'common.cart_page_estdelivery'|cxTranslate}} :</span>
									<span class="f-14" *ngIf="!entry?.estimatedDeliveryDate"
										class="checkout-estimate-empty">{{'common.checkout_estimateDeliveryDate_empty'|cxTranslate}}
									</span>
									<span class="f-14" *ngIf="entry?.estimatedDeliveryDate"
										class="checkout-estimate-empty">{{entry?.estimatedDeliveryDate}}
									</span>
								</div>
								<ng-template #closeit></ng-template>
							</div>


							<div class="checkout-required-block d-flex align-items-center"
								*ngFor="let item of entry.associatedEntries">
								<div class="del-quantity">
									{{'common.basket_page_emea_orderQty'|cxTranslate}} : {{item?.estimatedQuantity}}
								</div>

								<div class="checkout-estimateDeliveryDate " *ngIf="(item?.updateable)">
									<span class="f-13"> {{'common.cart_page_estdelivery'|cxTranslate}} :</span>
									<span class="f-14" *ngIf="!item?.estimatedDeliveryDate"
										class="checkout-estimate-empty">{{'common.checkout_estimateDeliveryDate_empty'|cxTranslate}}
									</span>
									<span class="f-14" *ngIf="item?.estimatedDeliveryDate"
										class="checkout-estimate-empty">{{item?.estimatedDeliveryDate}}
									</span>
								</div>
								<ng-template #closeit></ng-template>
							</div>
						</div>

					</li>
				</ng-container>
				<!-- Split end -->

				<ng-container *ngIf="!entry.associatedEntries">
					<div class="thumb product-list-item-img">
						<a [routerLink]="{  cxRoute: 'product',params:entry?.product } | cxUrl">
							<cx-media
								[container]="entry?.product?.images['PRIMARY'] || entry?.product?.images"></cx-media>
						</a>
					</div>
					<div class="checkout-EntryNumber">
						{{entry?.updatedEntryNumber}}
					</div>
					<div class="details">
						<div class="checkout-Entryitem-block  d-flex">
							<div class="col-xs-12 col-sm-12 ">
								<div class="name">
									<a [routerLink]="{  cxRoute: 'product',params:entry?.product } | cxUrl">
										<strong class="name">{{entry?.product?.code}}</strong>
									</a>
									<span class="f-14 d-block" *ngIf="entry?.product?.typenumber">
										{{entry?.product?.typenumber}}
									</span>
								</div>
								<div class="">
									<br>
									{{entry?.product?.name}}
									<br>
								</div>
								<div class="" *ngIf="entry?.customPartNumber">
									{{'common.text_cust_part_no'|cxTranslate}}: {{entry?.customPartNumber}}
								</div>
								<div class="checkout-Entryitem-qty">
								</div>
							</div>
						</div>
						<div class="col-xs-12 col-sm-12 d-flex flex-column order-confirmation-price-block">
							<span *ngIf="fleetPrideGroup">
								<span class="checkout-netprice-block" *ngIf="showNetPrice$|async">
									<span class="checkout-label-priceLabel ">
										{{'common.popup_cart_customer_price'|cxTranslate}}
									</span>
									<span class="checkout-input-price float-right">
										<strong
											*ngIf="!entry?.product?.customerPrice?.formattedValue || entry?.product?.customerPrice?.formattedValue.indexOf('-') > -1; else netPrice">
											{{'common.basket_page_poa'|cxTranslate}}
										</strong>
										<ng-template #netPrice>
											{{entry?.product?.customerPrice?.formattedValue}}&nbsp;
											{{entry?.product?.customerPrice?.currencyIso}}
										</ng-template>
									</span>
								</span>
								<p class="checkout-netprice-block  " *ngIf="showCorePrice$|async">
									<span class="checkout-label-priceLabel">
										{{'common.basket_page_coredeposit'|cxTranslate}}&nbsp;&nbsp;
									</span>
									<span class="checkout-input-price float-right">
										<strong
											*ngIf="!entry?.surcharge?.formattedValue || entry?.surcharge?.formattedValue.indexOf('-') > -1 ; else corePrice">
											{{'common.basket_page_poa'|cxTranslate}}
										</strong>
										<ng-template #corePrice>
											{{entry?.surcharge?.formattedValue}}&nbsp;
											{{entry?.surcharge?.currencyIso}}
										</ng-template>
									</span>
								</p>
							</span>
						</div>
						<div class="del-quantity pl-3 ">
							<div class="mob-qty ">
								{{'common.product_detail_quantity'|cxTranslate}}: {{entry?.formattedQuantity}}
							</div>
							<div class="checkout-requiredDeliveryDate">
								{{'common.cart_page_reqdelivery'|cxTranslate}} :
								{{entry?.requestedDeliveryDate}}
							</div>
							<div class="checkout-estimateDeliveryDate " *ngIf="(entry?.updateable)">
								<span class="f-13"> {{'common.cart_page_estdelivery'|cxTranslate}}
									:</span>
								<span class="f-14" *ngIf="!entry.estimatedDeliveryDate"
									class="checkout-estimate-empty">{{'common.checkout_estimateDeliveryDate_empty'|cxTranslate}}
								</span>
								<span class="f-14" *ngIf="entry.estimatedDeliveryDate"
									class="checkout-estimate-empty">{{entry?.estimatedDeliveryDate}}
								</span>
							</div>
						</div>
					</div>
				</ng-container>
			</div>
		</div>
		<div class="account-orderdetail order-confirmation-orderdetails mb-3">
			<div class="account-orderdetail__footer">
				<div class="row">
					<div class="col-sm-6 col-md-7 col-lg-8">
					</div>
					<div class="col-sm-6 col-md-5 col-lg-4">
						<div class="orderTotal order-confirmation-orderTotal">
							<div class="row" *ngIf="showNetPrice$|async">
								<div class="col-xs-7 col-sm-7 order-confirmation-orderTotal-label">
									{{'common.order_form_subtotal'|cxTranslate}}:</div>
								<div class="col-xs-5 col-sm-5 order-confirmation-subTotal-Unit">

									<div class="text-right"
										*ngIf=" (orderConfirmation?.subTotal?.formattedValue.indexOf('-') < 0) &&
                                (orderConfirmation?.minOrderCharge?.formattedValue.indexOf('-')<0) &&
                               (orderConfirmation.totalPriceWithTax?.formattedValue.indexOf('-') < 0);else nosubTotalPrice ">
										{{orderConfirmation?.subTotal?.formattedValue}}&nbsp;{{orderConfirmation?.subTotal?.currencyIso}}
									</div>
									<ng-template #nosubTotalPrice>
										<div class="text-right">{{'common.basket_page_poa'|cxTranslate}}</div>
									</ng-template>
								</div>
								<div class="col-xs-7 col-sm-7 order-confirmation-orderTotal-label"
									*ngIf="orderConfirmation?.minOrderCharge?.value??0 >0">
									<div class="whiteSpace">
										{{'common.text_account_order_min_NA'|cxTranslate}}</div>
								</div>
								<div class="col-xs-5 col-sm-5 order-confirmation-subTotal-Unit"
									*ngIf="orderConfirmation?.minOrderCharge?.value??0 >0">

									<div class="text-right"
										*ngIf=" (orderConfirmation?.subTotal?.formattedValue.indexOf('-') < 0) &&
                                (orderConfirmation?.minOrderCharge?.formattedValue.indexOf('-')<0) &&
                               (orderConfirmation.totalPriceWithTax?.formattedValue.indexOf('-') < 0);else nominOrderChargePrice ">
										{{orderConfirmation?.minOrderCharge?.formattedValue}}&nbsp;
										{{orderConfirmation?.minOrderCharge?.currencyIso}}
									</div>
									<ng-template #nominOrderChargePrice>
										<div class="text-right">{{'common.basket_page_poa'|cxTranslate}}</div>
									</ng-template>
								</div>
								<div class="col-xs-12 col-sm-12 row border-top my-2"></div>
								<div class="col-xs-7 col-sm-7 order-confirmation-orderTotal-label-Total">
									<div class="totals">
										{{'common.basket_page_totals_total'|cxTranslate}}</div>
								</div>
								<div class="col-xs-5 col-sm-5 order-confirmation-subTotal-Unit-Total">

									<div class="text-right totals"
										*ngIf="fleetPrideGroup && (orderConfirmation?.subTotal?.formattedValue.indexOf('-') < 0) &&
                                (orderConfirmation?.minOrderCharge?.formattedValue.indexOf('-')<0) &&
                               (orderConfirmation.totalPriceWithTax?.formattedValue.indexOf('-') < 0);else nototalPrice ">
										{{orderConfirmation?.totalPriceWithTax?.formattedValue}}&nbsp;
										{{orderConfirmation?.totalPriceWithTax?.currencyIso}}
									</div>
									<ng-template #nototalPrice>
										<div class="text-right totals">{{'common.basket_page_poa'|cxTranslate}}</div>
									</ng-template>
								</div>

							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="float-right col-xs-12 col-sm-12  my-3">
			<div class="float-right">
				<button (click)="continueShopping()" class="btn button-launch">
					{{'common.general_continue_shopping'|cxTranslate}}</button>
			</div>
		</div>
	</div>
</ng-container>